import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./../Content-Library/AddContentModal";
import Select from "react-select";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { useSelector } from "react-redux";
import { addDoc, arrayUnion, doc, getDoc, serverTimestamp, setDoc, updateDoc } from "firebase/firestore";
import { firestore } from "../../firebase";

const AddFeaturedCourseModal = ({
  isOpen,
  onClose,
  setRefreshFeaturedCourse,
}) => {
  const [title, setTitle] = useState("");
  const [featuredCourseLink, setFeaturedCourseLink] = useState("");
  const [thumbnail, setThumbnail] = useState(null);
  const [allUsers, setAllUsers] = useState();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userName = useSelector((state) => state.userData?.userDetails?.name);

  const handleThumbnailChange = (e) => {
    setThumbnail(e.target.files[0]);
  };

  const getAllUsers = async () => {
    try {
      const response = await apiServiceHandler(
        "GET",
        "api/user/all/active",
        {}
      );
      setAllUsers(response.data);
    } catch (error) {
      console.error("Error getting getAllUsers:", error);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, [isOpen]);

  const sendAddFeaturedCourse = async () => {
    if (!title || !featuredCourseLink) {
      toastr.error("Please fill in all fields");
      throw new Error("Please fill in all fields");
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("course_url", featuredCourseLink);
    formData.append("thumbnail", thumbnail);

    try {
      // console.log(formData, title, recordingURL, selectedOption, thumbnail, 'formData is here....')
      const response = await apiServiceHandler(
        "POST",
        "api/featured/courses",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.auth) {
        toastr.success(response.message);
        setRefreshFeaturedCourse(true);
        setTitle("");
        setFeaturedCourseLink("");
        setThumbnail(null);
        const members = [];
        allUsers?.map((user) => {
          if (userDetails?._id === user?._id) {
            members.push({ id: user?._id, seen: true });
          } else {
            members.push({ id: user?._id, seen: false });
          }
        });
        // firebase functions

        const docRef = doc(firestore, "courses", response._id);
        const body = {
          title: title,
          courseLink: featuredCourseLink,
          courseId: response._id,
          lastSeen: members,
          createdBy: userName,
        };

        await setDoc(docRef, body);
        await setDoc(
          docRef,
          {
            lastMessageTimestamp: serverTimestamp(),
          },
          { merge: true }
        );
        onClose();
        for (const user of allUsers) {
          const userId = user?._id
          const userRef = doc(firestore, "coursenotifications", userId);
          // Fetch the current notifications document to check if the notification exists
          const userDoc = await getDoc(userRef);
          if (userDoc.exists()) {
            const data = userDoc.data();
            const notifications = data.notifications || [];
            // Check if the notification with the same chatId already exists
            const existingNotification = notifications.find(
              (notification) => notification.courseId === response._id
            );

            if (existingNotification) {
              // If the notification exists, update the timestamp and read status
              const updatedNotifications = notifications.map((notification) =>
                notification.courseId === response._id
                  ? {
                      ...notification,
                      timestamp: Date.now(),
                      read: userDetails?._id !== userId ? false : true,
                    } // Update the existing notification
                  : notification
              );
              // Update the notifications array in the Firestore document
              await updateDoc(userRef, {
                notifications: updatedNotifications,
              });

              console.log("Notification updated successfully.");
            } else {
              // If the notification doesn't exist, add a new one using arrayUnion
              await setDoc(
                userRef,
                {
                  notifications: arrayUnion({
                    courseId: response?._id,
                    timestamp: Date.now(),
                    read: userDetails?._id !== userId ? false : true,
                  }),
                },
                { merge: true }
              );

              console.log("New notification added.");
            }
          } else {
            // If no notifications document exists, create one with the new notification
            await setDoc(
              userRef,
              {
                notifications: [
                  {
                    courseId: response._id,
                    timestamp: Date.now(),
                    read: userDetails?._id !== userId ? false : true,
                  },
                ],
              },
              { merge: true }
            );

            console.log("Notification document created with new notification.");
          }
        }
      } else {
        toastr.error(
          response.message || "Failed to add featured course. Please try again."
        );
      }
    } catch (error) {
      console.error("Failed to add featured course");
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Add Featured Course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Title</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Recording URL</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={featuredCourseLink}
                onChange={(e) => setFeaturedCourseLink(e.target.value)}
              />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Thumbnail</div>
            <div className="form-input__wrapper">
              <input
                type="file"
                className="form-input__input"
                accept="image/*"
                onChange={handleThumbnailChange}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }}>
        <button className="send-invite__btn" onClick={sendAddFeaturedCourse}>
          <span className="send-invite-button__label">Add</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddFeaturedCourseModal;
